import 'assets/scss/components/maincontentheader.scss';
import { useState, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { EmbedSiteShortContext } from 'App.js';

// logos
//import logoLargeChillblastDark from 'assets/img/chillblast-logo-black.svg';
//import logoSmallChillblastDark from 'assets/img/chillblast-logo-symbol-black.svg';
import logoLargeChillblast from 'assets/img/chillblast-logo-white.svg';
import logoSmallChillblast from 'assets/img/chillblast-logo-symbol-white.svg';

import logoLargeCCL from 'assets/img/ccl_logo_chevron_light_lime.png';
import logoSmallCCL from 'assets/img/ccl_logo_chevron_mobile_light_lime.png';
//import logoLargeCCLDark from 'assets/img/ccl_logo_chevron_dark_lime.png';
//import logoSmallCCLDark from 'assets/img/ccl_logo_chevron_mobile_dark_lime.png';

export default function Logo({ settings })
{
    const runningInDev = process.env.NODE_ENV === 'development' ? true : false;

    // const prefersDarkColorScheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? true : false; // not catering for dark/light switch atm
    const site = useContext(EmbedSiteShortContext);

    //#region Event handlers

    const beforeUnload = () =>
    {
        setShowLeavingModal(true);
    }

    //#endregion Event Handlers

    const [showLeavingModal, setShowLeavingModal] = useState(false);

    const handleLeavingModalClose = () =>
    {
        setShowLeavingModal(false);
    }

    let logoLarge = "";
    let logoSmall = "";
    //let logoLargeDark = "";
    //let logoSmallDark = "";

    // svg files need to be prefixed with the assetBaseUrl as react doesn't convert them to base64 like other images under 8KB
    // png files under 8KB will get converted to base64 by webpack
    switch (site)
    {
        case "chillblast":
            logoLarge = runningInDev ? logoLargeChillblast : process.env.REACT_APP_ASSET_BASE_URL + logoLargeChillblast;
            logoSmall = runningInDev ? logoSmallChillblast : process.env.REACT_APP_ASSET_BASE_URL + logoSmallChillblast;
            //logoLargeDark = runningInDev ? logoLargeChillblastDark : process.env.REACT_APP_ASSET_BASE_URL + logoLargeChillblastDark;
            //logoSmallDark = runningInDev ? logoSmallChillblastDark : process.env.REACT_APP_ASSET_BASE_URL + logoSmallChillblastDark;
            break;
        case "ccl":
            logoLarge = logoLargeCCL;
            logoSmall = logoSmallCCL;
            //logoLargeDark = logoLargeCCLDark;
            //logoSmallDark = logoSmallCCLDark;
            break;
      default:
    }

    return (
        <>
            <a style={{ cursor: 'pointer' }} onClick={beforeUnload}>
                <picture>
                    <source className="header-logo img-fluid" width="auto" media="(max-width: 450px)" srcSet={logoSmall}></source>
                    <img className="header-logo img-fluid" width="auto" src={logoLarge} alt="Logo"></img>
                </picture>
            </a>

            { /* Leaving Modal React Style */}
            <Modal className={site + "-modal"} show={showLeavingModal} onHide={() => { handleLeavingModalClose() }} backdrop="static" keyboard={false}>
                <Modal.Header className="border-bottom-0 ps-5 py-4 pe-4">
                    <Button variant="secondary" type="button" className="close-button btn-close float-end" data-bs-dismiss="modal" aria-label="Close" onClick={() => { handleLeavingModalClose() }}></Button>
                </Modal.Header>
                <Modal.Body className="border-bottom-0 px-5 pt-0 pb-3">
                    <h1 className="modal-title mb-4" style={site === "chillblast" ? { color: "#FFF" } : {}}>Are you sure you want to leave this page?</h1>
                    <label className="modal-top-label text-muted mb-4 fw-bold">None of your changes will be saved.</label>
                    <div className="action-buttons-container">
                        <a style={{ textDecoration: 'none' }} href="/">
                            <button type="button" className="yes-button primary-button d-block w-100 py-3 mb-2 text-casing" style={site === "chillblast" ? { color: "#000" } : {}}>Yes, I want to leave</button>
                        </a>
                        <button type="button" className="no-button white-button d-block w-100 py-3 text-casing" onClick={handleLeavingModalClose} >No, go back</button>
                    </div>
                </Modal.Body>
                <Modal.Footer className="modal-footer border-top-0 px-5 pb-5 pt-0">
                </Modal.Footer>
            </Modal>

        </>
    );
}